import { searchContent } from '@plone/volto/actions';
import { flattenToAppURL } from '@plone/volto/helpers';

export const DEFAULT_FONTE = '/transparencia/consultas-publicas';

const fromObjectBrowser = (value, fallback) => {
  const first = Array.isArray(value) ? value[0] : value;
  const id = first && (first['@id'] || first);
  return id ? flattenToAppURL(id) : fallback;
};

export const sourcesOf = (data) => [
  {
    key: 'consultas',
    path: fromObjectBrowser(data.fonte, DEFAULT_FONTE),
    depth: 1,
    portalTypes: ['News Item'],
  },
];

export const searchOptions = (source) => ({
  // o caminho vai na URL do searchContent (contexto do @search): via
  // path.query na raiz, o SSR interno não resolve (falta o prefixo físico)
  'path.depth': source.depth,
  portal_type: source.portalTypes,
  sort_on: 'effective',
  sort_order: 'descending',
  b_size: 300,
  metadata_fields: ['Subject', 'effective', 'modified'],
});

export default function getConsultationSearchAsyncData({ dispatch, id, data }) {
  return sourcesOf(data).map((source) =>
    dispatch(
      searchContent(
        source.path,
        searchOptions(source),
        `agsusConsultationSearch_${id}_${source.key}`,
      ),
    ),
  );
}
